module.exports = __webpack_public_path__ + "img/barcode.dec1ffdb.svg";